import React from 'react'
import styled from 'styled-components'

import AdminHeader from 'live/components/header/ui/admin/header'

import OptionsCard from './OptionsCard'

const AlarmConfig = styled(({ className }) => {
    return (
        <div className={`admin-content ${className}`}>
            <div className="admin-inner">
                <AdminHeader>
                    <h2>Alarm Configurations</h2>
                </AdminHeader>

                <div className="admin-body admin-form">
                    <h2>Acknowledgement Settings</h2>

                    <div className="row">
                        <div className="col-md-6 form-area">
                            <OptionsCard
                                optionName="reason"
                                optionEndpointPath="reasons"
                                fields={[
                                    {
                                        name: 'reason',
                                        label: 'Reason',
                                        type: 'text'
                                    },
                                    {
                                        name: 'color',
                                        label: 'Color',
                                        type: 'color'
                                    }
                                ]}
                            />

                            <OptionsCard
                                optionName="resolution"
                                optionEndpointPath="resolutions"
                                fields={[
                                    {
                                        name: 'resolution',
                                        label: 'Resolution',
                                        type: 'text'
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})`
    .admin-body > h2 {
        font-size: 25px;
        font-family: SourceSansPro-Regular;
        color: #000;
    }
`

export default AlarmConfig
